<template>
  <AppWidget title="Расчет печи" @resize="set_style($event)">
    <AppWidgetPart>
      <AppSlider v-model="slide_index" @slide="calc()" :style="widget_style" :disableds="[
        slideDisabled1,
        slideDisabled2,
        slideDisabled2 || slideDisabled3,
      ]">
        <AppSlide index="1" title="Характеристики материала" :cur_index="slide_index" :disabled="slideDisabled1">
          <AppParagraph :title="getInputTitle('E4')">
            <AppDropdownlist
              class="field short"
              :options="materials"
              v-model="inputFieldsData.E4.value"
              display-field="name"
              value-field="name"
              placeholder="Введите или выберите значение"
              @update:modelValue="setMaterial()"
              :class2="{error: inputFieldsData.E4.error}"
            />
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E5')">
            <input
              class="field short"
              type="number"
              placeholder="Введите значение"
              v-model.number="inputFieldsData.E5.value"
              @change="calc()"
              :class="{error: inputFieldsData.E5.error}"
            />
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E6')">
            <input
              class="field short"
              placeholder="Введите значение"
              type="number"
              v-model="inputFieldsData.E6.value"
              @change="calc()"
              :class="{error: inputFieldsData.E6.error}"
            />
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E7')">
            <input
              class="field short"
              placeholder="Введите значение"
              type="number"
              v-model="inputFieldsData.E7.value"
              @change="calc()"
              :class="{error: inputFieldsData.E7.error}"
            />
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E8')">
            <input
              class="field short"
              placeholder="Введите значение"
              type="number"
              v-model="inputFieldsData.E8.value"
              @change="calc()"
              :class="{error: inputFieldsData.E8.error}"
            />
          </AppParagraph>
          <AppParagraph title="Массовая доля фракций материала с диаметром частиц, мм">
            <div class="field short" style="border: none;background: none">
              <table>
                <thead>
                <tr>
                  <th>от, мм</th>
                  <th>до, мм</th>
                  <th>доля, %</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(val, index) in fractions" :key="index">
                  <td>
                    <input
                      class="field field2"
                      type="number"
                      placeholder="Введите значение"
                      v-model="inputFieldsData['C'+val].value"
                      @change="calc()"
                      :class="{error: inputFieldsData['C'+val].error}"
                    />
                  </td>
                  <td>
                    <input
                      class="field field2"
                      type="number"
                      placeholder="Введите значение"
                      v-model="inputFieldsData['D'+val].value"
                      @change="calc()"
                      :class="{error: inputFieldsData['D'+val].error}"
                    />
                  </td>
                  <td>
                    <input
                      class="field field2"
                      type="number"
                      placeholder="Введите значение"
                      v-model="inputFieldsData['E'+val].value"
                      @change="calc()"
                      :class="{error: inputFieldsData['E'+val].error}"
                    />
                  </td>
                  <td>
                    <button class="button fa fa-regular fa-trash-can" @click="delFractionFields(val)"
                            v-if="inputFieldsData['E'+val]"></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class=" field short" style="display: flex; gap: 5px; padding: 0; border: none;">
              <button class="button" style="width: 100%;" @click="addFractionFields()"
                      :disabled="this.getFractionsCount()=== 13">Добавить фракцию
              </button>
            </div>
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E32')">
            <input
              class="field short"
              placeholder="Введите значение"
              type="number"
              v-model="inputFieldsData.E32.value"
              @change="calc()"
              :class="{error: inputFieldsData.E32.error}"
            />
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E36')">
            <input
              class="field short"
              style="flex-shrink: 0;flex-grow: 1"
              placeholder="Введите значение"
              type="number"
              v-model="inputFieldsData.E36.value"
              @change="calc()"
              :class="{error: inputFieldsData.E36.error}"
            />
            <div class="field short"
                 style="border:none;background: none;gap:5px;padding:0;margin-top:5px;display: flex;">
              <button class="button" @click="findHeatCapacity(this.inputMaterial)"
                      title="Установить значение по материалу">По материалу
              </button>
              <button class="button" @click="getHeatCapacityForOrganic()" title="Установить значение как для органики">
                Как для органики
              </button>
              <button class="button" @click="getHeatCapacityForInorganic()"
                      title="Установить значение как для неорганики">Как для неорганики
              </button>
            </div>
          </AppParagraph>
        </AppSlide>
        <AppSlide index="2" title="Технологические параметры" :cur_index="slide_index" :disabled="slideDisabled2">
          <AppParagraph :title="getInputTitle('E9')">
            <select
              class="field short"
              v-model="inputFieldsData.E9.value"
              @change="calc()"
              :class="{error: inputFieldsData.E9.error}"
            >
              <option disabled value="undefined" style="display: none; color: grey">Выберите значение</option>
              <option v-for="val in  inputFieldsData.E9.options" :value="val" :key="val">
                {{ val }}
              </option>
            </select>
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E10')">
            <input
              class="field short"
              placeholder="Введите значение"
              type="number"
              v-model="inputFieldsData.E10.value"
              @change="calc()"
              :class="{error: inputFieldsData.E10.error}"
            />
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E13')">
            <input
              class="field short"
              placeholder="Введите значение"
              type="number"
              v-model="inputFieldsData.E13.value"
              @change="calc()"
              :class="{error: inputFieldsData.E13.error}"
            />
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E14')">
            <input
              class="field short"
              placeholder="Введите значение"
              type="number"
              v-model="inputFieldsData.E14.value"
              @change="calc()"
              :class="{error:
              inputFieldsData.E14.error}"
            />
          </AppParagraph>
          <AppParagraph title="E14.3. Температура после обжига" v-if="isBurner">
            <input
              class="field short"
              type="number"
              :value="timeAfterBurnig"
              readonly
              style="background: none;border:1px solid lightgray;"
            />
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E15')">
            <input
              class="field short"
              placeholder="Введите значение"
              type="number"
              v-model="inputFieldsData.E15.value"
              @change="calc()"
              :class="{error: inputFieldsData.E15.error}"
            />
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E16')">
            <div class="field short" style="display: flex;border:none;background:none;padding:0;">
              <input
                class="field"
                placeholder="Введите значение"
                type="number"
                v-model="inputFieldsData.E16.value"
                @change="calc()"
                :class="{error: inputFieldsData.E16.error}"
              />
              <AppInfo><span>Рекомендованный диапазон 110 - 200</span></AppInfo>
            </div>
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E33')">
            <input
              class="field short"
              placeholder="Введите значение"
              type="number"
              v-model="inputFieldsData.E33.value"
              @change="calc()"
              :class="{error: inputFieldsData.E33.error}"
            />
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E34')">
            <input
              class="field short"
              placeholder="Введите значение"
              type="number"
              v-model="inputFieldsData.E34.value"
              @change="calc()"
              :class="{error: inputFieldsData.E34.error}"
            />
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E35')">
            <select class="field short" v-model="inputFieldsData.E35.value" @change="calc()"
                    :class="{error: inputFieldsData.E35.error}">
              <option disabled value="undefined" style="display: none; color: grey">Выберите значение</option>
              <option v-for="val in inputFieldsData.E35.options" :value="val" :key="val">
                {{ val }}
              </option>
            </select>
          </AppParagraph>
        </AppSlide>
        <AppSlide index="3" title="Конструктив" :cur_index="slide_index" :disabled="slideDisabled3">
          <AppParagraph :title="getInputTitle('E11')">
            <select
              class="field short"
              v-model="inputFieldsData.E11.value"
              @change="calc()"
              :class="{error: inputFieldsData.E11.error}"
            >
              <option disabled value="undefined" style="display: none; color: grey">Выберите значение</option>
              <option v-for="val in  inputFieldsData.E11.options" :value="val" :key="val">
                {{ val }}
              </option>
            </select>
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E12')">
            <select
              class="field short"
              v-model="inputFieldsData.E12.value"
              @change="calc()"
              :class="{error: inputFieldsData.E12.error}"
              :disabled="inputFieldsData.E11.value !== inputFieldsData.E11.options[1]"
            >
              <option disabled value="undefined" style="display: none; color: grey">Выберите значение</option>
              <option v-for="val in  inputFieldsData.E12.options" :value="val" :key="val">
                {{ val }}
              </option>
            </select>
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E17')">
            <input
              class="field short"
              placeholder="Введите значение"
              type="number"
              v-model="inputFieldsData.E17.value"
              @change="calc()"
              :class="{error: inputFieldsData.E17.error}"
              :disabled="inputFieldsData.E12.value === inputFieldsData.E12.options[1]"
            />
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E38')">
            <select
              class="field short"
              v-model="inputFieldsData.E38.value"
              @change="calc()"
              :class="{error: inputFieldsData.E38.error}"
            >
              <option disabled value="undefined" style="display: none; color: grey">Выберите значение</option>
              <option v-for="val in inputFieldsData.E38.options" :value="val" :key="val">
                {{ val }}
              </option>
            </select>
          </AppParagraph>
          <AppParagraph :title="getInputTitle('E58')">
            <select
              class="field short"
              v-model="inputFieldsData.E58.value"
              @change="calc()"
              :class="{error: inputFieldsData.E58.error}"
            >
              <option disabled value="undefined" style="display: none; color: grey">Выберите значение</option>
              <option v-for="val in inputFieldsData.E58.options" :value="val" :key="val">
                {{ val }}
              </option>
            </select>
          </AppParagraph>
        </AppSlide>
        <!-- итоговое окно для мобильного варианта -->
        <AppSlide index="4" title="Итог" :cur_index="slide_index">
          <TheResult v-if="!lastRequestError" :result="outputFieldsData" :isLoading="isLoading"></TheResult>
          <TheResultWithError v-if="lastRequestError" :errorData="outputFieldsData"></TheResultWithError>
        </AppSlide>
      </AppSlider>
    </AppWidgetPart>
    <AppWidgetPart style="overflow: auto">
      <TheResult v-if="!lastRequestError" :result="outputFieldsData" :inputs="inputFieldsData"
                 :isLoading="isLoading"></TheResult>
      <TheResultWithError v-if="lastRequestError" :errorData="outputFieldsData"></TheResultWithError>
    </AppWidgetPart>
  </AppWidget>
</template>

<script>
import {AppDropdownlist, AppParagraph, AppSlide, AppSlider, AppWidget, AppWidgetPart} from "@/components/ui";

import {InputFields} from "@/components/InputFields";
import TheResult from "@/components/TheResult.vue";
import TheResultWithError from "@/components/TheResultWithError.vue";

import {Materials} from "@/components/Materials";
import AppInfo from "@/components/ui/AppInfo.vue";
import {useAxios} from "@/composables/axios";

/**
 * - фильтрация при наборе в выпадающе списке
 * */

export default {
  name: "App",
  components: {
    AppInfo,
    AppWidget,
    AppWidgetPart,
    AppParagraph,
    AppSlide,
    AppSlider,
    AppDropdownlist,
    TheResult,
    TheResultWithError,
  },
  data() {
    return {
      controller: new AbortController(),
      widget_style: undefined,
      isLoading: false,
      slide_index: 1,


      inputFieldsData: InputFields,
      outputFieldsData: {},
      price: 0,
      lastRequestError: false,
      massPartsCells: [
        'C19', 'C20', 'C21', 'C22', 'C23', 'C24', 'C25', 'C26', 'C27', 'C28', 'C29', 'C30', 'C31',
        'D19', 'D20', 'D21', 'D22', 'D23', 'D24', 'D25', 'D26', 'D27', 'D28', 'D29', 'D30', 'D31',
        'E19', 'E20', 'E21', 'E22', 'E23', 'E24', 'E25', 'E26', 'E27', 'E28', 'E29', 'E30', 'E31'
      ],
      massPartsCellsRows: [19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
    };
  },

  mounted() {
    this.loadFromStorage()
    this.calc()
  },

  computed: {
    slideDisabled1() {
      return false;
    },

    slideDisabled2() {
      if (
        !!this.isNotValid('E4', this.inputFieldsData.E4) ||
        !!this.isNotValid('E5', this.inputFieldsData.E5) ||
        !!this.isNotValid('E6', this.inputFieldsData.E6) ||
        !!this.isNotValid('E7', this.inputFieldsData.E7) ||
        !!this.isNotValid('E8', this.inputFieldsData.E8) ||
        !!this.isNotValid('E32', this.inputFieldsData.E32) ||
        !!this.isNotValid('E36', this.inputFieldsData.E36) ||
        this.getFractionSum() !== 100
      ) {
        return true;
      }


      let res
      this.massPartsCellsRows.forEach((row) => {

        if (
          (this.inputFieldsData['C' + row] && this.isNotValid('C' + row, this.inputFieldsData['C' + row])) ||
          (this.inputFieldsData['D' + row] && this.isNotValid('D' + row, this.inputFieldsData['D' + row])) ||
          (this.inputFieldsData['E' + row] && this.isNotValid('E' + row, this.inputFieldsData['E' + row]))
        ) {
          res = true
          return false
        }
      })

      return !!res;
    },

    slideDisabled3() {
      return !!this.isNotValid('E9', this.inputFieldsData.E9) ||
        !!this.isNotValid('E10', this.inputFieldsData.E10) ||
        !!this.isNotValid('E13', this.inputFieldsData.E13) ||
        !!this.isNotValid('E14', this.inputFieldsData.E14) ||
        !!this.isNotValid('E15', this.inputFieldsData.E15) ||
        !!this.isNotValid('E16', this.inputFieldsData.E16) ||
        !!this.isNotValid('E33', this.inputFieldsData.E33) ||
        !!this.isNotValid('E34', this.inputFieldsData.E34) ||
        !!this.isNotValid('E35', this.inputFieldsData.E35);
    },

    materials() {
      return Materials.map((e, i) => {
        return {id: i, name: e.b, value: e.b}
      })
    },
    inputMaterial() {
      return this.inputFieldsData.E4.value
    },

    fractions() {
      let tmp = []
      this.massPartsCellsRows.forEach((row) => {
        if (this.inputFieldsData?.[`E${row}`]) {
          tmp.push(row)
        }
      })

      return tmp
    },

    timeAfterBurnig() {
      if (isNaN(this.inputFieldsData.E14.value)) return ''
      return this.inputFieldsData.E14.value * .7
    },

    isBurner() {
      return this.inputFieldsData.E12.value === this.inputFieldsData.E12.options[0]
    }
  },

  methods: {
    loadFromStorage() {
      try {
        if (localStorage.furnaceCalcInputData) {
          let inputs = JSON.parse(localStorage.furnaceCalcInputData)

          for (const key in inputs) {
            if (!this.inputFieldsData[key]) {
              this.inputFieldsData[key] = {}
            }

            this.inputFieldsData[key].value = inputs[key].value
          }
        }
      } catch (e) {
        //
      }
    },
    requestData() {
      let tmp = {};

      for (let key in InputFields) {
        let el = InputFields[key]
        if (el.readonly === true) return;
        tmp[key] = el.value;
      }

      this.massPartsCellsRows.forEach((row) => {
        if (this.inputFieldsData['E' + row] === undefined) {
          tmp['C' + row] = 0
          tmp['D' + row] = 1
          tmp['E' + row] = 0
        }
      })

      return tmp;
    },

    set_style(e) {
      this.widget_style = e.style;
    },

    isNotValid(key, input) {
      if (input === undefined) {
        return false
      }
      if (input.value === undefined || input.value === '') {
        return `Поле '${input.title || key}': Поле не заполнено`
      } else if (['E7', 'E8'].includes(key) && (input.value < 0 || input.value > 99.99)) {
        return `Поле '${input.title || key}': Значение должно быть в диапазоне 0 - 99.99`
      } else if (['E13', 'E14', 'E15', 'E16', 'E32', 'E33'].includes(key) && (input.value < -273)) {
        return `Поле '${input.title || key}': Значение должно быть в больше -273`
      } else if (this.massPartsCells.includes(key) && (input.value < 0 || input.value > 100)) {
        return `Поле '${input.title || key}': Значение должно быть в диапазоне 0 - 100`
      } else if (['E34'].includes(key) && (input.value < 0 || input.value > 100)) {
        return `Поле '${input.title || key}': Значение должно быть в диапазоне 0 - 100`
      } else if (!['E4', 'E9', 'E8', 'E11', 'E12', 'E35', 'E38', 'E58'].includes(key) && isNaN(+input.value)) {
        return `Поле '${input.title || key}': Значение должно быть числом`
      }

      return false
    },

    validate() {
      let tmp = {}
      for (let key in this.inputFieldsData) {
        let el = this.inputFieldsData[key]
        let isNotValid = this.isNotValid(key, el)
        if (isNotValid) {
          tmp[key] = [isNotValid]
        }
      }

      let partsSum = this.getFractionSum()

      if (partsSum !== 100) {
        tmp['partSum'] = ["Массовая доля фракций материала с диаметром частиц: сумма долей не равна 100%"]
      }


      if (this.getFractionsCount() === 0) {
        tmp['partCount'] = ["Массовая доля фракций материала с диаметром частиц: не введены данные"]
      }

      return tmp
    },

    calc() {
      localStorage.furnaceCalcInputData = JSON.stringify(this.inputFieldsData)

      this.lastRequestError = false

      if (this.inputFieldsData.E11.value !== this.inputFieldsData.E11.options[1]) {
        this.inputFieldsData.E12.value = this.inputFieldsData.E12.options[1]
        this.inputFieldsData.E17.value = 0
      } else if (this.inputFieldsData.E12.value === this.inputFieldsData.E12.options[1]) {
        this.inputFieldsData.E17.value = 0
      }


      if (this.inputFieldsData.E12.value === this.inputFieldsData.E12.options[1]) {
        //сушка
        this.inputFieldsData.E14.title = 'Температура материала после сушки'
      } else if (this.inputFieldsData.E12.value === this.inputFieldsData.E12.options[0]) {
        // обжиг
        this.inputFieldsData.E14.title = 'Температура во время обжига'
      }


      //валидация
      let validateResult = this.validate()


      for (let key in this.inputFieldsData) {
        let el = this.inputFieldsData[key]
        el.error = !!validateResult[key];
      }

      // ошибки есть
      if (Object.keys(validateResult).length > 0) {
        this.lastRequestError = true

        // показываем ошибки, соответствующие слайду
        let fieldtoValidate;
        if (this.slide_index === 1) {
          fieldtoValidate = ['E4','E5','E6','E7','E8','E32','E36', 'partSum', 'partCount']
          fieldtoValidate = fieldtoValidate.concat(this.massPartsCells)
        } else if (this.slide_index === 2) {
          fieldtoValidate = ['E9', 'E10', 'E13', 'E14', 'E15', 'E16', 'E33', 'E34', 'E35']
        } else if (this.slide_index === 3) {
          fieldtoValidate = ['E11', 'E12', 'E17', 'E38', 'E58']
        }

        const uniqueValues = new Set();
        const newObj = {};

        // убираем дубли
        for (const key in validateResult) {
          if (Object.prototype.hasOwnProperty.call(validateResult, key)) {
            const values = validateResult[key];
            values.forEach((item) => {
              if (!uniqueValues.has(item) && fieldtoValidate.includes(key)) {
                uniqueValues.add(item);
                if (!newObj[key]) {
                  newObj[key] = []
                }

                newObj[key].push(item)
              }
            })
          }
        }

        if (Object.keys(newObj).length > 0) {
          this.outputFieldsData = {
            level: 'Внимание',
            message: (Object.keys(newObj).length === 1 ? 'Ошибка' : 'Ошибки') + ' в веденных данных',
            errors: newObj
          }

        } else {
          this.outputFieldsData = {
            level: 'Внимание',
            message: 'Отлично! Переходите к следующей вкладке',
            errors: {}
          }
        }

        return
      }

      this.outputFieldsData = undefined

      let requestData = this.requestData()

      requestData.calcMode = new URLSearchParams(window.location.search).get('mode')


      this.controller.abort()
      this.controller = new AbortController();

      this.isLoading = true
      console.log('стартуем')
      useAxios()
        .get('/optimal', {
          params: requestData,
          signal: this.controller.signal
        })
        .then((response) => {
          this.outputFieldsData = response?.data?.data

          this.inputFieldsData.E58.options = this.outputFieldsData?.transmissions
          if (this.outputFieldsData?.transmissions.length === 1 && this.outputFieldsData?.transmissions[0]) {
            this.inputFieldsData.E58.value = this.outputFieldsData?.transmissions[0]
          }
          this.isLoading = false
        })
        .catch((error) => {
          if (error.name === 'CanceledError') {
            return
          }
          this.isLoading = false

          this.lastRequestError = true
          this.outputFieldsData = error
        });
    },

    findHeatCapacity(material) {
      let materialProps = this.getMaterialFromList(material)

      if (!materialProps?.d) {
        return alert(`Не удалось найти значение теплоемкости для материала '${material}'`)
      }

      this.inputFieldsData.E36.value = materialProps?.c
      this.calc()
    },

    getHeatCapacityForOrganic() {
      this.inputFieldsData.E36.value = 1590
      this.calc()
    },

    getHeatCapacityForInorganic() {
      this.inputFieldsData.E36.value = 1050
      this.calc()
    },


    getInputTitle(cell) {
      let title = this.inputFieldsData[cell].title + (this.inputFieldsData[cell].ei ? ', ' + this.inputFieldsData[cell].ei : '')
      if (process.env.NODE_ENV === 'development') {
        return cell + '. ' + title;
      } else {
        return title;
      }
    },

    delFractionFields(row) {
      delete this.inputFieldsData[`C${(row)}`]
      delete this.inputFieldsData[`D${(row)}`]
      delete this.inputFieldsData[`E${(row)}`]

      let result = []

      this.massPartsCellsRows.forEach((row) => {
        if (
          this.inputFieldsData['C' + row] !== undefined ||
          this.inputFieldsData['D' + row] !== undefined ||
          this.inputFieldsData['E' + row] !== undefined
        ) {
          result.push({
            min: this.inputFieldsData['C' + row],
            max: this.inputFieldsData['D' + row],
            value: this.inputFieldsData['E' + row]
          })

          delete this.inputFieldsData[`C${(row)}`]
          delete this.inputFieldsData[`D${(row)}`]
          delete this.inputFieldsData[`E${(row)}`]
        }
      })

      let row2 = 19
      result.forEach((fraction) => {
        this.inputFieldsData[`C${(row2)}`] = fraction.min
        this.inputFieldsData[`D${(row2)}`] = fraction.max
        this.inputFieldsData[`E${(row2)}`] = fraction.value
        row2++
      })

      this.calc()
    },

    addFractionFields() {
      let nextRow = undefined
      this.massPartsCellsRows.forEach((row) => {
        if (!nextRow && this.inputFieldsData['E' + row] === undefined) {
          nextRow = row
        }
      })

      if (!nextRow) return

      const title = 'Массовая доля фракций материала с диаметром частиц'
      this.inputFieldsData[`C${(nextRow)}`] = {
        title: 'Массовая доля фракций материала с диаметром частиц',
        value: nextRow === 19 ? 0 : this.inputFieldsData[`D${(nextRow - 1)}`].value,
        error: true
      }
      this.inputFieldsData[`D${(nextRow)}`] = {title, value: undefined, error: true}
      this.inputFieldsData[`E${(nextRow)}`] = {title, value: undefined, error: true}

      this.calc()
    },

    getFractionSum() {
      return this.massPartsCellsRows.reduce((a, c) => {
        return a + Number(this.inputFieldsData['E'+ c]?.value || 0)
      }, 0)
    },

    getFractionsCount() {
      let n = 0
      this.massPartsCellsRows.forEach((row) => {
        if (this.inputFieldsData['E' + row] !== undefined) {
          n++
        }
      })

      return n
    },

    setMaterial() {
      // всякая логика с полями
      let material = this.getMaterialFromList(this.inputFieldsData.E4.value)

      if (material) {
        this.setMaterialProps(material)
      }

      this.calc()
    },
    setMaterialProps(material) {
      this.inputFieldsData.E5.value = material.d
      this.inputFieldsData.E6.value = material.e
      this.inputFieldsData.E32.value = material.f
      this.inputFieldsData.E36.value = material.c

      // если у материала признак противотока и направление газа не определено, то устанавливаем
      if (material.g && !this.inputFieldsData.E11.value) {
        this.inputFieldsData.E11.value = this.inputFieldsData.E11.options[1]
      }
    },

    getMaterialFromList(materialName) {
      if (!materialName) {
        return
      }

      return Materials.find((item) => {
        return item.b === materialName
      });
    }
  },
};
</script>

<style scoped>
table {
  font-size: 10pt;


  padding: 0;
  margin: 0;
}

table .field2 {
  width: 90%;

}
</style>

<style>

.button {
  padding: 5px;
  cursor: pointer;
}

.ellipsis {
  overflow: hidden;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.field {
  color: black;
  padding: 6px;
  font-size: 1rem;
  background: #fafafa;
  transition: all 0.2s linear;
  border: 1px solid lightgray;
  flex-grow: 1;
  box-sizing: border-box;
  cursor: pointer;
  outline: none;
  display: block;
}

.field[disabled] {
  color: lightgray;
}

.field:focus {
  border-color: orangered;
}

.field.short {
  margin-right: 23px;
}

.required {
  border-color: red;
  border-style: dashed;
}

hr {
  border: 1px solid #fc5a0a;
  width: 80%;
  margin: 3px auto;
  padding: 0;
}

.noselect {
  /* запрет выделения текста мышкой */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.error-response {
  background: red;
}

.error {
  background-color: rgba(255, 0, 0, 0.1);
  border: 1px solid red !important;
}

</style>
